import React from 'react'
import Login from '../components/auth/js/Login'
const LoginPage = () => {
  return (
    <Login/>
  )
}

export default LoginPage